import React from "react";
import { ArrowUpRight, Instagram } from "lucide-react";
import logo from "../assets/jalsa-logo.jpeg";

function Footer({ scrollTo, setReserveOpen }) {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <img src={logo} alt="Jalsa" />
          <p>Kitchen · Bar · Music</p>
        </div>
        <div className="footer-links">
          <div>
            <span>Explore</span>
            <button onClick={() => scrollTo("story")}>Our Story</button>
            <button onClick={() => scrollTo("menu")}>Menu</button>
            <button onClick={() => scrollTo("events")}>Events</button>
          </div>
          <div>
            <span>Connect</span>
            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
              <Instagram size={15} /> Instagram
            </a>
            <button onClick={() => scrollTo("contact")}>Contact</button>
          </div>
        </div>
        <button className="footer-reserve" onClick={() => setReserveOpen(true)}>
          Reserve <ArrowUpRight size={18} />
        </button>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Jalsa Restobar. All rights reserved.</span>
        <span>Designed for nights worth remembering.</span>
      </div>
    </footer>
  );
}

export default Footer;
